import qs from "qs";
import { ACTIVE_CLASS } from "../lib/constants";

const $CARDS_CONTAINER = $(".js-card-container-product");
const $TABS = $("[data-boiler-type]");

const restoreActualTabsAndCarsState = () => {
  const { boiler } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  if (boiler) {
    $CARDS_CONTAINER.addClass(boiler);

    $TABS.removeClass(ACTIVE_CLASS);
    $(`[data-boiler-type=${boiler}]`).addClass(ACTIVE_CLASS);
  }
};

const switchProductCards = () => {
  const addQueryParamsToUrl = (param, val) => {
    const url = new URL(window.location.href);

    url.searchParams.set(param, val);

    window.history.replaceState({}, document.title, url);
  };

  $TABS.on("click", function () {
    const $tab = $(this);

    $TABS.removeClass(ACTIVE_CLASS);
    $tab.addClass(ACTIVE_CLASS);

    addQueryParamsToUrl("boiler", $tab.attr("data-boiler-type"));

    $CARDS_CONTAINER
      .removeClass()
      .addClass(
        `card__container card__container--product js-card-container-product ${$tab.attr(
          "data-boiler-type"
        )}`
      );
  });
};

export const productTabsFunctions = () => {
  restoreActualTabsAndCarsState();
  switchProductCards();
};
